import { z } from 'zod';
import { PaymentRowSchema } from './finance';

/** Home of the back office (ScrDashboard). Sections are null when the user cannot see that module. */
export const DashboardSchema = z.object({
  students: z.object({ count: z.number().int(), previousYear: z.number().int().nullable() }),
  admissions: z
    .object({ pending: z.number().int(), stale: z.number().int(), responseDays: z.number().int() })
    .nullable(),
  finance: z
    .object({
      paidMillimes: z.number().int(),
      dueMillimes: z.number().int(),
      pendingCheques: z.number().int(),
    })
    .nullable(),
  attendance: z
    .object({ isoWeek: z.number().int(), weekHours: z.number(), nearThreshold: z.number().int() })
    .nullable(),
  programs: z.array(
    z.object({
      id: z.uuid(),
      name: z.string(),
      nameAr: z.string().nullable(),
      enrolled: z.number().int(),
      firstYear: z.number().int(),
      capacity: z.number().int(),
      admissionCapacity: z.number().int(),
    }),
  ),
  todos: z.object({
    juries: z.number().int().nullable(),
    incompleteApplications: z.number().int().nullable(),
    staleApplications: z.number().int().nullable(),
    pendingCheques: z.number().int().nullable(),
    timetableConflicts: z.number().int().nullable(),
  }),
  latestPayments: z.array(PaymentRowSchema).nullable(),
});
export type Dashboard = z.infer<typeof DashboardSchema>;
